import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from './constants';
import { WarModel } from '../models/WarModel';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  serviceURL = "/v1/Wars/";
  genericURL = "/v1/Generic/"
  token: string = localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  getRunningEvents() {

    const url = Constants.baseURL + this.serviceURL + 'GetAllRunningEvents';

    return this.http.get(url);
  }

  postWar(model) {
    const url = Constants.baseURL + this.serviceURL + 'CreateWar';

    return this.http.post(url, model);
  }

  getWar(id) {
    const url = Constants.baseURL + this.serviceURL + 'GetWar?WarID=' + id;

    return this.http.get(url);
  }

  getMyWars() {
    const url = Constants.baseURL + this.serviceURL + 'GetMyWars';
    return this.http.get(url);
  }

  getActivewars(page, sort, search) {
    let url
    if (search)  {
      url = `${Constants.baseURL}${this.genericURL}GetActiveWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}&Search=${search}`;
    } else {
      url = `${Constants.baseURL}${this.genericURL}GetActiveWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}`;
    }
    // const url = `${Constants.baseURL}${this.genericURL}GetActiveWarsWithToken?Token=${this.token}&Page=${page}`;
    return this.http.get(url);
  }
  GetAvailableWars() {
    const url = `${Constants.baseURL}${this.genericURL}GetAvailableWarsWithToken?Token=${this.token}`;
    return this.http.get(url);
  }

  getInactivewars(page, sort, search) {
    let url
    if(search) {
        url = `${Constants.baseURL}${this.genericURL}GetInActiveWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}&Search=${search}`;
    } else{
      url = `${Constants.baseURL}${this.genericURL}GetInActiveWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}`;
    }

    return this.http.get(url);
  }

  getAllwars(page, sort, search) {
    let url
    if(search) {
        url = `${Constants.baseURL}${this.genericURL}GetAllWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}&Search=${search}`;
    } else{
      url = `${Constants.baseURL}${this.genericURL}GetAllWarsWithToken?Token=${this.token}&Page=${page}&Sort=${sort}`;
    }

    return this.http.get(url);
  }

  getWarSnapshot(id) {
    const url = Constants.baseURL + this.serviceURL + 'GetWarSnapshot?WarID=' + id;

    return this.http.get(url);
  }

  getWarSnapshotWithEntry(id, entryId) {
    const url = Constants.baseURL + this.serviceURL +  `GetWarSnapshot?WarID=${id}&EntryID=${entryId}`;
    return this.http.get(url);
  }

  getWarLeaderboard(id) {
    const url = Constants.baseURL + this.serviceURL + 'GetWarLeaderBoard?WarID=' + id;

    return this.http.get(url);
  }

  getUnfinishedGames(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetUnfinishedGames?WarID=' + warID;

    return this.http.get(url);
  }

  getPlayerProps(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetPlayerProps?WarID=' + warID;

    return this.http.get(url);
  }

  getUnfinishedFirstInnings(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetUnfinishedFirstInnings?WarID=' + warID;

    return this.http.get(url);
  }

  getUnfinishedFirst5Innings(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetUnfinishedFirst5Innings?WarID=' + warID;

    return this.http.get(url);
  }

  getOdds(eventID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetOdds?EventID=' + eventID;

    return this.http.get(url);
  }

  getMyPosition(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'GetMyPosition?WarID=' + warID;

    return this.http.get(url);
  }

  joinWar(warID: String) {
    const url = Constants.baseURL + this.serviceURL + 'JoinWar?WarID=' + warID;

    return this.http.post(url, warID);
  }

  updateWarAsync(data) {
    const url = Constants.baseURL + '/v1/Odd/' + 'UpdateOddsAsync';

    return this.http.post(url, data);
  }

  //Lines new logic
  getLinesDropdown(warID: String) {
    const url = `${Constants.baseURL}${this.genericURL}GetGameLeaugeAndPeriods?WarID=${warID}`

    return this.http.get(url);
  }

  getLinesData(warID: String, league: String, period: String) {
    const url = `${Constants.baseURL}${this.genericURL}GetGameOdds?WarID=${warID}&Leauge=${league}&Period=${period}`;

    return this.http.get(url);
  }
}
